/**
 * Choisit la forme qui convient à `n`, dans les règles de `locale`.
 *
 * Aucune règle de pluriel n'est écrite ici : `Intl.PluralRules` les connaît déjà, langue
 * par langue, mieux qu'une condition `n > 1` recopiée à la main ne le ferait — le français
 * accorde déjà 0 et 1 au singulier, ce qu'une condition naïve oublierait pour 0.
 */
export function accorder(locale, n, formes) {
    const regle = new Intl.PluralRules(locale).select(n);
    return formes[regle] ?? formes.other;
}
//# sourceMappingURL=plural.js.map